export interface BrokerLoggedInViewModel {
  email: string;
}

export const mocked_BrokerLoggedInViewModel_Get: BrokerLoggedInViewModel = {
  email: 'test@test.com'
};
